/* eslint-disable import/no-unresolved */
import React from 'react';
import injectSheet, { ThemeProvider } from 'react-jss';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';

import { ITheme, TGetStyles, PropsWithDefaultStyle } from './types';

// Updated emptyTheme to include required properties from the unified ITheme interface
const emptyTheme: ITheme = {};

export function withDefaultStyles<P>(
  WrappedComponent: React.ComponentType<P>,
  getStyles: TGetStyles = () => ({})
): React.FC<PropsWithDefaultStyle<P>> {
  const StyledComponent = injectSheet(({ components = {}, core = {} }: ITheme) => getStyles(components, core))(WrappedComponent);

  const HOC: React.FC<PropsWithDefaultStyle<P>> = props => (
    <ThemeProvider theme={emptyTheme}>
      <StyledComponent {...props} />
    </ThemeProvider>
  );

  HOC.displayName = `withDefaultStyles(${getDisplayName(WrappedComponent)})`;

  hoistNonReactStatics(HOC, WrappedComponent);

  return HOC;
}
